/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServizioMensaDovutoDaAnnullareDTO { 
    id_ricarica?: string;
    anno?: number;
    mese?: number;
    importo?: number;
    identificativo_univoco_dovuto?: string;
}

